import FinishScreen from './FinishScreen.jsx';

export default FinishScreen;